const isFinnishStaffEntry = staffEntry => {
  if (!staffEntry || typeof staffEntry !== 'object') return false

  const role = staffEntry.role
  if (role !== 'HeadScout' && role !== 'Scout') return false

  const teamName = String(staffEntry.nationalTeamName || '').toLowerCase()

  // Match both Finnish and English naming variants, including U21 names.
  return teamName.includes('suomi') || teamName.includes('finland')
}

export const isU21NationalTeam = nationalTeamName =>
  /\bU\s?-?21\b|\bUnder\s?21\b/i.test(nationalTeamName || '')

export const hasTeamSpiritAccess = (user, isU21) => {
  if (!user || !Array.isArray(user.staff)) return false

  return user.staff.some(staffEntry => {
    const hasStaffRole =
      staffEntry?.role === 'HeadScout' || staffEntry?.role === 'Scout'
    return hasStaffRole && isU21NationalTeam(staffEntry.nationalTeamName) === isU21
  }) || hasFinnishStaffAccess(user)
}

export const hasFinnishStaffAccess = user => {
  if (!user || !Array.isArray(user.staff)) return false
  return user.staff.some(isFinnishStaffEntry)
}

export default {
  hasFinnishStaffAccess,
}
